<section class="section-div">
  <div class="content-details">
    <div class="container">
      <div class="search-title">
        <h4>Search</h4>
        <div class="search-engine">
          <form action="" [formGroup]="searchGroup">
            <input
              type="text"
              placeholder="Search"
              formControlName="incubateeName"
              (input)="searchValue($event.target.value)"
              class="form-control"
              name=""
              id=""
            />
          </form>
        </div>
      </div>
      <div>
        <div class="incubatee-div-modal">
          <div class="row">
            <h5 class="tit mb-2" *ngIf="display == false">Incubatee Details</h5>
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-12"
              *ngFor="let list of searchList; let i = index"
            >
              <div class="incubatee-title">
                <div class="row">
                  <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                    <h5>{{ i + 1 }}. {{ list.incubateeName }}</h5>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          Startup Name : <b> {{ list.startupName }}</b>
                        </p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          Founder Name : <b> {{ list.founderName }}</b>
                        </p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          District :
                          <span *ngIf="list.registeredDistrict != 'Other'">
                            <b>{{ list.registeredDistrict }}</b>
                          </span>
                          <span *ngIf="list.registeredDistrict == 'Other'">
                            <b>{{ list.otherDistrict }}</b>
                          </span>
                        </p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          Incubation Center Name :
                          <b> {{ list.incubatorName }}</b>
                        </p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          Availed Schemes : <b> {{ list.availedSchemes }}</b>
                        </p>
                      </div>
                      <div class="col-lg-6 col-md-6 col-12">
                        <p class="mb-2">
                          Stage : <b> {{ list.incubateeStage }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                    <div class="text-center">
                      <img
                        [src]="list.logoFileName"
                        class="img-fluid incubatee-img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-g-12 col-md-12 col-sm-12 col-12"
              *ngIf="display == true"
            >
              <div class="text-center">
                <div class="text-center no-data-div">
                  <img
                    src="assets/images/startup-logo.png"
                    class="img-fluid"
                    alt=""
                  />
                  <h4>Incubatee Not Found</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-3">
          <button mat-raised-button color="warn" (click)="clearSearch()">
            Home
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
